// extracted by mini-css-extract-plugin
module.exports = {"breadcrumb":"Breadcrumb_breadcrumb__1IO92","breadcrumbSeparator":"Breadcrumb_breadcrumbSeparator__1TziV"};